import styled, { css, keyframes } from 'styled-components'

const fade = keyframes`
  from, to {
    opacity: 0.15;
  }
  50% {
    opacity: 1;
  }
`

export const Container = styled.div`
  display: grid;
  place-items: center;
  position: relative;
`

export const Wrapper = styled.div(
  ({ theme }) => css`
    position: relative;
    transition: transform ${theme.transition.duration.sm} ease-in-out;
  `,
)

export const Bar = styled.div(
  ({ theme }) => css`
    position: absolute;
    top: 50%;
    left: 50%;
    transform: translate(-50%, -50%);
    width: 2rem;
    border-radius: ${theme.border.radius['4']};
    opacity: 0.15;
    transition: all ${theme.transition.duration.sm} ease-in-out;
    // NOTE: Animation duration for 'Radial Loader' is component unique
    animation: ${fade} 2s infinite ease-in-out;
    background-color: currentColor;
    border: ${theme.border.size['3']} solid currentColor;
  `,
)
